import React from 'react';
import './Articles.css';

const articles = [
  {
    label: 'Press Release',
    title: 'Michigan-Made Punk Rock Comedy \'Neutrals\' Marks Feature Debut for Local Filmmakers',
    href: './articles/neutrals-press-release.pdf',
  },
  {
    label: "Director's Statement",
    title: 'Jacob Horne on Neutrals',
    href: './articles/neutrals-directors-statement.pdf',
  },
];

export default function Articles() {
  return (
    <div className="articles-window">
      <h1 className="articles-heading">Articles</h1>
      <ul className="articles-list">
        {articles.map(({ label, title, href }) => (
          <li key={href} className="article-card">
            <a href={href} target="_blank" rel="noopener noreferrer">
              <span className="article-label">{label}</span>
              <span className="article-title">{title}</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
